import { EVALUATION_RESULT } from '@/model/Logistic/PackageItem/EvaluationResult';
import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import {
  PACKAGE_ITEM_RESOLUTION,
  PACKAGE_ITEM_STOCK_RESOLUTION,
} from '@/model/Logistic/PackageItem/PackageItemResolution';
import { PRODUCT_STATUS } from '@/model/Logistic/PackageItem/ProductStatus';
import { PRODUCT_TYPES } from '@/model/Logistic/PackageItem/ProductTypes';

import { RETURN_ITEM_TYPE } from '../Logistic/Reception/ReturnItemType';
import { SHIPPING_ITEM_REFERENCE } from '../Logistic/Shipment/ShipmentReference';
import { ServiceOrderItem } from '../ServiceOrder/ServiceOrderItem';

export enum ITEM_COMPARISON_STATUS {
  CORRECT = 'CORRECT',
  REVIEW = 'REVIEW',
  REVIEW_STOCK = 'REVIEW_STOCK',
  RESOLVED = 'RESOLVED',
}

/**
 * Relación directa entre un item de envío y su item de recepción vinculado.
 * Si no existe recepción, se considera como pendiente o no devuelto.
 */
export interface PackageItemComparison {
  id: string; // `${shipmentItem.id}` o `${shipmentItem.id}-${receptionItem.id}`
  productId: number;
  productName: string;
  productType: PRODUCT_TYPES;
  productStatus: PRODUCT_STATUS;

  shipmentItem?: PackageItem;
  receptionItem?: PackageItem; // puede no existir (si no se devolvió o si no se generó la recepción)

  sentAmount: number;
  usedAmount?: number;
  discardedAmount?: number;
  technicianStockAmount?: number;
  receivedAmount: number;

  shipmentReference?: SHIPPING_ITEM_REFERENCE;
  returnItemType?: RETURN_ITEM_TYPE;

  status: ITEM_COMPARISON_STATUS;
  evaluationResult?: EVALUATION_RESULT;
  resolution_status?: PACKAGE_ITEM_RESOLUTION;
  stock_resolution_status?: PACKAGE_ITEM_STOCK_RESOLUTION;

  serviceOrderItem?: ServiceOrderItem; // Para facilitar la resolución de casos, se incluye el service order item asociado al package item

  notes?: string; // observaciones del evaluador
}
